import { useCallback } from "react";
import type { KeyboardEvent } from "react";
import { useSetRecoilState } from "recoil";
import { imageLightboxAtom, rectFromElement } from "../../contexts/imageLightbox.recoil";

interface UseImageLightboxTriggerParams {
	src: string;
	alt?: string;
}

export const useImageLightboxTrigger = ({ src, alt }: UseImageLightboxTriggerParams) => {
	const setLightbox = useSetRecoilState(imageLightboxAtom);

	const onImageClick = useCallback(
		(target: HTMLImageElement) => {
			setLightbox({
				src,
				alt,
				originRect: rectFromElement(target.getBoundingClientRect()),
			});
		},
		[alt, setLightbox, src]
	);

	const onImageKeyDown = useCallback(
		(event: KeyboardEvent<HTMLImageElement>) => {
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				onImageClick(event.currentTarget);
			}
		},
		[onImageClick]
	);

	return { onImageClick, onImageKeyDown };
};
